import DetachedIcon from './DetachedIcon';

export default DetachedIcon;



// WEBPACK FOOTER //
// ./src/shared/components/detachedIcon/index.ts